import React, { useState, useEffect } from 'react'
import { useTransition, animated, config } from 'react-spring'
import PropTypes from 'prop-types'

const FadeInOutVideo = ({ count }) => {
    const [index, set] = useState(0)
    const [Images, setImages] = useState([])


    useEffect(() => {
        const randomItem = () => {
            const arrayOfImages = [
                'videos/amazing_zoom-in.webm',
                'videos/balo_dolly-zoom-in.webm',
                'videos/city_dolly-zoom-in.webm',
                'videos/rockwater_zoom-in.webm',
                'videos/View_dolly-zoom-in.webm',
                'videos/barg_dolly-zoom-in.webm',
                'videos/Bild_Lugna_Rummet_Nacka_4_dolly-zoom-in.webm',
                'videos/eco-eco_dolly-zoom-in.webm',
                'videos/jade_chaloos_iran_dolly-zoom-in.webm',
                'videos/kafsh_dolly-zoom-in.webm'
            ];

            let uniqueArray = [];
            while (uniqueArray.length < count || uniqueArray.length > arrayOfImages.length) {
                var randomItemFromArray = Math.floor(Math.random() * arrayOfImages.length);
                if (uniqueArray.indexOf(randomItemFromArray) === -1) {
                    uniqueArray = [...uniqueArray, randomItemFromArray];
                }
            }

            return (uniqueArray.map((VALUE, INDEX) => { return ({ id: INDEX, url: arrayOfImages[VALUE] }) }));


        }

        setImages(randomItem());

        let intervalInternalID = setInterval(() => set(state => (state + 1) % count), 4000)

        return function () {
            console.log("cleaning");
            clearInterval(intervalInternalID);
        }
    }, [count])

    const transition = useTransition(Images[index], {
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        config: config.molasses,
    })

    return transition((values, item) => (
        //<animated.div id="imageBackground" style={{ ...values, backgroundImage: `url(https://images.unsplash.com/${item.url}&auto=format&fit=crop)` }} />
        <animated.video style={{ ...values }} preload="auto" autoPlay="autoplay" loop="loop" muted="muted" playsInline >
            <source src={item.url} type="video/webm"></source>
        </animated.video>
    ))
}

FadeInOutVideo.defaultProps = {
    count: 4,
}

FadeInOutVideo.propTypes = {
    count: PropTypes.number,
}

export default FadeInOutVideo
